package ui.widget

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.unit.*
import compose.assets.*
import compose.assets.svg.*


import ssoft.frontend.generated.resources.*
import tools.*

@Composable
fun WarningDialog(
    state: DialogState,
    title: String,
    message: String,
    confirmLabel: String,
    onDismiss: () -> Unit = {},
    onConfirm: () -> Unit = {}
) {
    Dialog(state) {
        DialogUI(
            Modifier.align(Alignment.Center),
            onDismissRequest = {
                state.hide()
                onDismiss()
            },
            title = {
                Row {
                    Icon(
                        imageVector = Svg.Alert,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                    Space(24.dp)
                    Text(
                        text = title,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            },
            confirmButton = {
                TextButton({
                    onConfirm()
                    state.hide()
                }) { Text(confirmLabel) }
            },
            dismissButton = {
                TextButton({
                    state.hide()
                    onDismiss()
                }) { Text(Res.string.dialog__action_cancel.rememberString()) }
            },
        ) {
            Text(message)
        }
    }
}

@Composable
fun WarningDialog(
    state: DialogState,
    title: String,
    messageState: State<String>,
    confirmLabel: String,
    onDismiss: () -> Unit = {},
    onConfirm: () -> Unit = {}
) {
    Dialog(state) {
        DialogUI(
            Modifier.align(Alignment.Center),
            onDismissRequest = {
                state.hide()
                onDismiss()
            },
            title = {
                Row {
                    Icon(
                        imageVector = Svg.Alert,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                    Space(24.dp)
                    Text(
                        text = title,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            },
            confirmButton = {
                TextButton({
                    onConfirm()
                    state.hide()
                }) { Text(confirmLabel) }
            },
            dismissButton = {
                TextButton({
                    state.hide()
                    onDismiss()
                }) { Text(Res.string.dialog__action_cancel.rememberString()) }
            },
        ) {
            Text(messageState.value)
        }
    }
}
